<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import AnimatedBackground from '../../AnimatedBackground.vue'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import TrackFull from './shared/TrackFull.vue'

defineProps({
  item: Object,
})
</script>

<template>
  <ToFullBottomRight>
    <AnimatedBackground :lottie="EFLoopAudioLevels02" :scale="3" :position="{ x: 568, y: -898 }" :backgroundColor="colors.q.cr.gray.primary" :color="colors.q.cr.gray.darker">
      <TrackFull label="Zometeen" :track="item.enrichment.track?.next" />
    </AnimatedBackground>
  </ToFullBottomRight>
</template>
